export default "__VITE_ASSET__05ea721e__"